import { Content } from './Content'
import { Title } from './Title'
import { Root } from './Root'
import { Group } from './Group'
import { Columns } from './Columns'
import { Footer } from './Footer'
import { Submit } from './Submit'
import { Table } from './Table'

export const Form = {
  Root,
  Content,
  Title,
  Group,
  Columns,
  Footer,
  Submit,
  Table
}
